import { Field, Label, Radio as HIRadio, RadioGroup } from '@headlessui/react'
import styled from 'styled-components'

import { textSizeM } from '@/styles/theme/fonts.ts'

const StyledRadio = styled(HIRadio)`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1.5px solid ${({ theme }) => theme.colors.common.accentDark};
  background-color: ${({ theme }) => theme.colors.common.white};
`

const RadioCircle = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.common.accentDark};
  opacity: 0;
  transition: opacity 0.2s;

  ${StyledRadio}[data-checked] & {
    opacity: 1;
  }
`

const RadioField = styled(Field)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 0;
  gap: 20px;
`

const RadioLabel = styled(Label)`
  ${textSizeM};
`

const Radio = ({ text, value }: { value: string; text: string }) => (
  <RadioField>
    <StyledRadio value={value}>
      <RadioCircle />
    </StyledRadio>
    <RadioLabel>{text}</RadioLabel>
  </RadioField>
)

const CardRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const StyledCardRadio = styled(HIRadio)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.colors.common.border};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.common.accentDark};
  font-weight: 500;
  padding: 14px 15px;
  width: 100%;

  &[data-checked] {
    background: ${({ theme }) => theme.colors.common.background};
    border: 1px solid ${({ theme }) => theme.colors.common.border};
  }
`

const CardRadio = ({ text, value }: { value: string; text: string }) => (
  <Field>
    <StyledCardRadio value={value}>{text}</StyledCardRadio>
  </Field>
)

export { CardRadio, CardRadioGroup, Radio, RadioGroup }
